<template>
  <div id="page-user-sort">
    <div  class="vx-card p-6">

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        class="ag-theme-material ag-grid-table"
        :gridOptions="gridOptions"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :components="components"
        rowSelection="multiple"
        colResizeDefault="shift"
        :floatingFilter="false"
        :enableRtl="$vs.rtl"
        :rowDragManaged="true"
        :animateRows="true"
        :suppressDragLeaveHidesColumns="true"
        :rowData="users"
      >
      </ag-grid-vue>

      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button
          id="button-with-loading"
          type="filled"
          @click="saveSort"
          class="mt-5 block"
          >登録する</vs-button
        >
        <vs-button
          type="border"
          class="mt-5 block"
          :to="{
            name: 'enterprise-management-user-list'
          }"
          >キャンセル</vs-button
        >
      </div>

    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererRetirementStatus from "./cell-renderer/CellRendererRetirementStatus.vue";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("enterpriseUserList");

export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererLink,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererRetirementStatus,
  },
  data() {
    return {
      searchCondition: {
        name: "",
        isRetirement: null, // 在籍状況では絞り込まない
        isDeleted: false, // 削除済は取得対象外
        page: 0,
        limit: 9999,
      },
      // AgGrid
      gridApi: null,
      gridOptions: {
        localeText: { noRowsToShow: "社員が見つかりませんでした" },
        context: {
          componentParent: this
        },
        suppressCellSelection: true
      },
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: null,
      // Cell Renderer Components
      components: {},
    };
  },
  computed: {
    ...mapState({
      users: state => state.users,
    }),
  },
  methods: {
    ...mapActions(["fetchUsers", "updateUsersSortOrder", "resetUserListState"]),

    async searchUsers() {
      let payload = {
        name: this.searchCondition.name,
        is_retirement: this.searchCondition.isRetirement,
        is_deleted: this.searchCondition.isDeleted,
        page: this.searchCondition.page,
        limit: this.searchCondition.limit
      };
      this.$vs.loading();
      try {
        await this.fetchUsers(payload);
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    async saveSort() {

      let usersListData = this.gridApi.getModel().rowsToDisplay.map(displayRow => displayRow.data);
      let payload = {
        sort_orders:  usersListData.map((user, index) => {
                        return { user_id: user.user_id, sort_order: (index + 1) };
                      })
      };
      this.$vs.loading({
        type: "default",
        container: "#button-with-loading",
        scale: 0.45
      });
      try {
        await this.updateUsersSortOrder(payload);
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.$vs.notify({
          title: "表示順序を更新しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$router.push({ name: "enterprise-management-user-list" });
      } catch (e) {
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.$vs.notify({
          title: "表示順序の更新に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check"
        });
      }
    },
    cleanup() {
      this.resetUserListState()
    }
  },
  beforeMount() {
    this.columnDefs = [
      {
        rowDrag: true,
        headerName: "",
        width: 30,
        field: "name",
      },
      {
        headerName: "ID",
        field: "user_id",
        width: 110
      },
      {
        headerName: "名前",
        field: "name",
        width: 220,
        cellRenderer: "CellRendererLink"
      },
      {
        headerName: "名前（ローマ字）",
        field: "name_en",
        width: 250
      },
      {
        headerName: "在籍状況",
        field: "retirement_date",
        filter: true,
        width: 150,
        cellRenderer: "CellRendererRetirementStatus"
      },
      {
        headerName: "退職日",
        field: "retirement_date",
        filter: false,
        width: 180
      },
    ];
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }
  },
  created() {
    this.searchUsers();
  },
  beforeDestroy() {
    this.cleanup();
  }
};
</script>

<style lang="scss" scoped>
#page-user-sort {
  .vs-avatar--con-img img {
    object-fit: cover;
  }
  .ag-theme-material {
    height: calc(100vh - 360px);
  }
  .vs-button {
    margin:0.5rem;
  }
  .con-vs-avatar {
    cursor : auto;
  }
}
</style>
